export default __webpack_public_path__ + "static/media/pattern10.e6e30401.png";